import React, { useEffect } from 'react';
import SetChoices from './mcqOptions';
import { appendScript } from '../../../../utils/appendScript';
import { removeScript } from '../../../../utils/removeScript';
import TopQuestion from '../../utils/question/topQuestion';
import { connect } from 'react-redux';
import ListAnimation from '../../../utils/animations/list';
const mapStateToProps = (state) => {
	const {
		rightSectionProps: { choices, questionNo, audioChoices, prompt },
		leftSectionProps: { videoId, question, imagesrc, queDesc, questionId },
	} = state.rootReducer.testPageDetails;

	return {
		choices,
		videoId,
		question,
		imagesrc,
		queDesc,
		prompt,
		questionId,
		questionNo,
		audioChoices,
	};
};
const Mcq = ({ choices, prompt, questionId, audioChoices }) => {
	useEffect(() => {
		appendScript('testMCQ');
		return () => {
			removeScript('testMCQ');
		};
	}, [questionId]);

	let choicelist = '';

	if (typeof choices !== 'undefined') {
		let seqIncrement = 0;
		choicelist = Object.keys(choices).map(function (choice) {
			if (choices[choice] === '') {
				return false;
			}
			seqIncrement = seqIncrement + 1;
			return (
				<SetChoices
					key={`choice_${questionId}_${choice}`}
					seqIncrement={seqIncrement}
					identifier={'mcqChoices'}
					choice={choice}
				/>
			);
		});
	}

	let audioChoicelist = '';
	if (typeof audioChoices !== 'undefined') {
		let seqIncrement = 0;
		audioChoicelist = Object.keys(audioChoices).map(function (choice) {
			if (choices[choice] === '') {
				return false;
			}
			seqIncrement = seqIncrement + 1;
			return (
				<li key={`${questionId}_${choice}`} className="list-item col-sm-5">
					<audio controls controlsList="nodownload">
						<source src="https://storage.googleapis.com/assets.thehindustep.in/audio_answers/2020/06/24/UID110843_STEP-IDS-16100380-8640420200624000846-1.mp3" />
					</audio>
					<div className="radio">
						<input
							title="1"
							type="radio"
							name="MCQchoices"
							id={`${questionId}_${choice}`}
							className="radio-field"
							defaultValue={choices[choice]}
						/>
						<label htmlFor={`${questionId}_${choice}`}></label>
					</div>
				</li>
			);
		});
	}

	return (
		<span>
			<section className="quiz-area-options">
				<TopQuestion />
				<section className="quiz-area-options">
					<h6>{prompt}</h6>
					{!!audioChoices && audioChoices.length > 0 ? (
						<ListAnimation>
							<ul className=" audioChoices">{audioChoicelist}</ul>
						</ListAnimation>
					) : (
						<ListAnimation>
							<ul>{choicelist}</ul>
						</ListAnimation>
					)}
					<input type="hidden" name="choosen-answer" className="choosen-answer" />
				</section>
			</section>
		</span>
	);
};

export default connect(mapStateToProps)(Mcq);
